import { useContext } from 'react';
import i18nContext from 'components/i18n-context';
import './CustomerTariffDetailsHeadRow.scss';

export const CUSTOMER_TARIFF_DETAILS_TABLE_HEADER = [
  {
    label: 'tariffInfo'
  },
  {
    label: 'tariffAmount'
  },
  {
    label: 'groupName'
  },
  {
    label: 'createdAtAndUpdatedAt'
  },
  {
    label: 'status'
  },
  {
    label: 'actions'
  }
];

export const CustomerTariffDetailsHeadRow = () => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {CUSTOMER_TARIFF_DETAILS_TABLE_HEADER.map((head) => (
        <th key={head.label} className={'customer-tariff-group-details-table-head'}>
          <div className={'customer-tariff-group-details-table-head-block'}>
            <span>{i18n.getMessage(`tariffs.details.table.header.${head.label}`)}</span>
          </div>
        </th>
      ))}
    </tr>
  );
};
